import type { Recipient } from '../../types/Recipient';
import { t } from '../../helpers/translation.helper';
import { RecipientRole } from '../types/enums/recipient-role';

export class RecipientsHelper {
  static getTranslatedRole(role: RecipientRole) {
    switch (role) {
      case RecipientRole.CC:
        return t('cc');
      case RecipientRole.Signer:
        return t('signer');
      case RecipientRole.ExternalApprover:
        return t('external_approver');
      case RecipientRole.Approver:
        return t('internal-approver');
      default:
        return '';
    }
  }

  static formatTitleAndCompanyName(recipient: Recipient, isDsr = false, showComma = true) {
    if (!recipient.companyName) {
      return '';
    }

    const conjunction = isDsr ? t('dsr_at_company') : t('at');
    const comma = showComma ? ',' : '';

    if (recipient.companyName && recipient.title) {
      return `${comma} ${recipient.title} ${conjunction} ${recipient.companyName}`;
    } else {
      return `${comma} ${recipient.companyName}`;
    }
  }
}
